if (!customElements.get('maker-home-carousel')) {
  customElements.define(
    'maker-home-carousel',
    class MakerHomeCarousel extends HTMLElement {
      connectedCallback() {
        this.ensureMakerNavigation();
        this.slides = Array.from(this.querySelectorAll('[data-maker-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-maker-dot]'));
        this.status = this.querySelector('[data-maker-status]');
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.active = 0;
        this.timer = null;
        this.manuallyPaused = false;
        this.touchStartX = null;

        if (this.slides.length < 2) return;

        this.querySelector('[data-maker-prev]')?.addEventListener('click', () => this.show(this.active - 1, true));
        this.querySelector('[data-maker-next]')?.addEventListener('click', () => this.show(this.active + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.makerDot), true)));

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.active - 1, true);
          if (event.key === 'ArrowRight') this.show(this.active + 1, true);
        });
        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (this.touchStartX === null) return;
          const delta = (event.changedTouches[0]?.clientX ?? this.touchStartX) - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(delta) < 40) return;
          this.show(this.active + (delta < 0 ? 1 : -1), true);
        }, { passive: true });

        this.desktop.addEventListener('change', () => this.startAutoplay());
        this.reducedMotion.addEventListener('change', () => this.startAutoplay());
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        });
        this.startAutoplay();
      }

      ensureMakerNavigation() {
        const targets = [
          ...document.querySelectorAll('.header__inline-menu > ul'),
          ...document.querySelectorAll('.menu-drawer__navigation > ul')
        ];

        targets.forEach((list) => {
          if (list.querySelector('a[href="/apps/maker"]')) return;
          const mobile = list.closest('.menu-drawer__navigation') !== null;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '/apps/maker';
          link.textContent = 'Maker';
          link.className = mobile
            ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset'
            : 'header__menu-item list-menu__item link link--text focus-inset';
          item.appendChild(link);
          list.appendChild(item);
        });
      }

      show(index, userInitiated = false) {
        this.active = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const current = slideIndex === this.active;
          slide.classList.toggle('is-active', current);
          slide.setAttribute('aria-hidden', String(!current));
        });
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === this.active)));
        if (this.status) this.status.textContent = `Showing slide ${this.active + 1} of ${this.slides.length}`;
        if (userInitiated) {
          this.manuallyPaused = true;
          this.stopAutoplay();
        }
      }

      stopAutoplay() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      startAutoplay() {
        this.stopAutoplay();
        if (
          this.dataset.autoplay !== 'true' ||
          !this.desktop.matches ||
          this.reducedMotion.matches ||
          this.manuallyPaused ||
          document.hidden
        ) return;
        const interval = Math.max(Number(this.dataset.interval) || 7000, 5000);
        this.timer = window.setInterval(() => this.show(this.active + 1), interval);
      }
    }
  );
}
